/**
 * Legal/terms versioning is a backend-owned policy (open decision §25). Until
 * the backend exposes the current required version via an API, this is a
 * config placeholder — do NOT hard-code policy decisions in components
 * (spec §1439). Replace with a backend-provided value when available.
 */
export const CURRENT_TERMS_VERSION = '2026-06-30';
